//for L&TT home Url only
export const baseUrl = "https://atci.lkm.accenture.com/lttmicrosite-apis"
//